import { ValueComponent } from "components/components/Component";
import { OutputBaseDefinition, OutputBaseComponent } from "components/output/baseOutputDefinition";
import template from "./icon.hbs";
import "./icon.scss";

export class IconOutput extends OutputBaseComponent<IconOutputDefinition> implements ValueComponent {

    public readonly componentType : string = "iconOutput";

    private stateValue: any;

    constructor(schema: IconOutputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    public getValue(): any {
        return this.stateValue;
    }

    public value(v: any) {
        this.stateValue = v;

        if ((typeof v !== "undefined") &&
            (typeof this.definition.icons  !== 'undefined' && this.definition.icons.length > 0) ) {

            let item = this.definition.icons.find(i => i.state === v);

            if(typeof item !== 'undefined') {
                $(this.view).find("i").prop("class", item.classIcon);
                if(typeof item.styleIcon !== 'undefined') {
                    $(this.view).find("i").prop("style", item.styleIcon);
                }
            }
        }
    }
}

export interface IconOutputDefinition extends OutputBaseDefinition {
    translate?: boolean;
    icons: Icon[];
}

export interface Icon {
    classIcon: string;
    state: any;
    styleIcon?: string;
}
